import isInsideEurope from './isInsideEurope';
import toArray from './toArray';

function hideOptionsBeforeYear(select, minimumYear) {
  toArray(select.querySelectorAll('option')).forEach((option) => {
    const year = parseInt(option.value, 10);

    option.style.display = year < minimumYear ? 'none' : 'block';
  });
}

function forceFirstAvailableOption(deliverySelect, minimumYear) {
  // Get the current selected year
  const selectedOption = parseInt(deliverySelect.value, 10);

  // If the current selected year is below the mininum year, we've to
  // change the value.
  if (!Number.isNaN(selectedOption) && selectedOption < minimumYear) {
    const visibleOptions = toArray(deliverySelect.children).filter((el) => el.style.display !== 'none');

    if (visibleOptions.length) {
      deliverySelect.value = visibleOptions[0].value;
    }
  }
}

function minimumYearForLocation(lat, lng) {
  const isInsideEuropeState = isInsideEurope(lat, lng);

  if (!isInsideEuropeState) {
    return 2024;
  }

  return null;
}

function getSelectedCoordinates() {
  // Get the geocoordinates from the location picker
  const locationValue = document.querySelector('[name="location"]')?.value;

  if (!locationValue) {
    return null;
  }

  return locationValue.split(',');
}

export default function validateAndSetDeliveryYears({
  minimumYear,
  deliverySelect,
}) {
  let newMinimumYear = minimumYear;

  const coordinates = getSelectedCoordinates();

  // If the user selected a location
  if (coordinates) {
    // Get the minimum delivery year for the location. Europe can be delivered earlier
    // than other parts of the world.
    const minimumLocationYear = minimumYearForLocation(coordinates[0], coordinates[1]);

    if (minimumLocationYear > newMinimumYear) {
      newMinimumYear = minimumLocationYear;
    }
  }

  hideOptionsBeforeYear(deliverySelect, newMinimumYear);

  forceFirstAvailableOption(deliverySelect, newMinimumYear);
}
